/**
 * @generated SignedSource<<db8c6b65254413feed3e27c47bf9a14b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoCircleWidgetOverview_Todo$data = {
  readonly createdAt: string;
  readonly expireAt: string | null;
  readonly status: TodoStatus;
  readonly " $fragmentType": "TodoCircleWidgetOverview_Todo";
};
export type TodoCircleWidgetOverview_Todo$key = {
  readonly " $data"?: TodoCircleWidgetOverview_Todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCircleWidgetOverview_Todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoCircleWidgetOverview_Todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "expireAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "5f8f881c478588251aa1a8527abb7f38";

export default node;
